import { defineAsyncComponent } from 'vue'
export default {
  colored: defineAsyncComponent(() => import("/app/app/layouts/colored.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/app/layouts/default.vue").then(m => m.default || m)),
  full: defineAsyncComponent(() => import("/app/app/layouts/full.vue").then(m => m.default || m))
}